import axiosInstance from './axiosInstance';
import BASE_URL from '../config/apiConfig';
import orchestratorAxios from './orchestratorAxios';
import ORCH_BASE_URL from '../config/orchConfig';

const API_URL = `${BASE_URL}/workflows/`;
const EXEC_API_URL = `${ORCH_BASE_URL}/`;

export const postWorkflowToBackend = async (payload) => {
  const response = await axiosInstance.post(`${API_URL}save`, payload);
  return response.data;
};

export const fetchScheduledStatus = async (workflowId) => {
  const response = await orchestratorAxios.get(
    `${EXEC_API_URL}workflow/${workflowId}/schedule-status`,
  );
  return response.data;
};

export const cancelWorkflowSchedule = async (workflowId) => {
  try {
    const response = await orchestratorAxios.patch(
      `${EXEC_API_URL}workflow/${workflowId}/schedules/cancel`
    );
    return response.data;
  } catch (error) {
    console.error('Cancel schedule failed:', error);
    throw error;
  }
};

export const fetchWorkflowConfiguration = async (workflowId) => {
  const response = await axiosInstance.get(`${API_URL}${workflowId}/configuration`);
  console.log('Raw response from backend:', response.data);
  return response.data;
};

export const deleteWorkflowById = async (workflowId) => {
  const response = await axiosInstance.delete(`${API_URL}${workflowId}`);
  return response.data;
};

export const triggerExecuteWorkflow = async (workflow_id, payload) => {
  const url = `${EXEC_API_URL}workflow/trigger/${workflow_id}`;
  const hasPayload = !(payload === undefined || payload === null);
  const response = hasPayload
    ? await orchestratorAxios.post(url, payload)
    : await orchestratorAxios.post(url);
  return response.data;
};

export const fetchWorkflowRunStatus = async (workflow_run_id) => {
  const response = await orchestratorAxios.get(`${EXEC_API_URL}job/${workflow_run_id}/status`);
  return response.data;
};

export const triggerCancelWorkflow = async (workflowRunId) => {
  try {
    const response = await orchestratorAxios.patch(`${EXEC_API_URL}workflow_runs/${workflowRunId}/cancel`);
    return response.data;
  } catch (error) {
    console.error('Cancel workflow failed:', error);
    throw error;
  }
};



export const patchToggleWorkflowStar = (workflowId, starred) => {
  return axiosInstance.patch(
    `/workflows/${encodeURIComponent(workflowId)}/star`,
    { starred }
  );
};

export const fetchWorkflowConnections = async (workflowId) => {
  const response = await axiosInstance.get(`${API_URL}${workflowId}/connections`);
  return response.data;
};

export const updateWorkflowName = async (workflow_id, name) => {
  const res = await orchestratorAxios.put(
    `${EXEC_API_URL}workflow/update-name/${workflow_id}`,
    { name }
  );
  return res.data;
};

export const fetchDailyRunWorkflowCount = async (workflow_id) => {
  const response = await axiosInstance.get(`${API_URL}${workflow_id}/daily-runs`);
  return response.data;
};